import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import ViewMode from './ViewMode'
import DatePickerRangeButton from '../datepickers/DatePickerRangeButton'
import { TaskStatusWrapper } from '@/modules/shared/components'
import { useDate } from '@/modules/drivers/stores/dateStore'
import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { DRIVER_ROUTES } from '../../routes-typed'
import {
  edgeToIsoDate,
  isoDatesToRange,
} from '@/modules/drivers/stores/dateStore.utils'

const ChartDetailsGroupControlBar: React.FC = () => {
  const { companyId, from, to } = useParams<{
    companyId: string
    from?: string
    to?: string
  }>()
  const navigate = useNavigate()
  const { range, setRange } = useDate()
  const { activeViewMode } = useDrivers()
  const { t } = useLocalize()

  React.useEffect(() => {
    if (!from || !to) return
    const fromUrl = isoDatesToRange(from, to)
    if (!fromUrl) return
    if (
      edgeToIsoDate(range?.startDate ?? null) === from &&
      edgeToIsoDate(range?.endDate ?? null) === to
    ) {
      return
    }
    setRange(fromUrl)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [from, to])

  return (
    <TaskStatusWrapper>
      <div className="tw-relative tw-flex tw-w-full tw-flex-row tw-items-center tw-justify-start tw-gap-2 tw-border-b md:tw-gap-4">
        <ViewMode padding />
        <div className="tw-text-nowrap tw-py-2 tw-font-medium tw-text-content-base">
          {activeViewMode === 'group'
            ? t('common.view-mode-group')
            : t('common.view-mode-single')}
        </div>
        <div className="tw-z-[200] tw-flex tw-w-full tw-flex-wrap-reverse tw-justify-end tw-gap-2 tw-px-4 tw-py-2 sm:tw-items-center sm:tw-justify-end sm:tw-gap-6">
          <DatePickerRangeButton
            iconAlign="left"
            size="small"
            highlightSelected
            clearable={false}
            initialDate={range ?? undefined}
            onChange={(dateRange) => {
              const fromStr = edgeToIsoDate(dateRange?.startDate ?? null)
              const toStr = edgeToIsoDate(dateRange?.endDate ?? null)
              if (!fromStr || !toStr || !companyId) return
              setRange(dateRange)
              navigate(
                DRIVER_ROUTES.groupChartDetails.buildPath({
                  companyId,
                  from: fromStr,
                  to: toStr,
                }),
              )
            }}
          />
        </div>
      </div>
    </TaskStatusWrapper>
  )
}

export default ChartDetailsGroupControlBar
